import axios from "axios";

const API_BASE_URL = "/api/products";

/**
 * Product API Service
 * Handles all HTTP requests related to product operations
 */
class ProductService {
  /**
   * Create a new product
   */
  async createProduct(productData) {
    try {
      const response = await axios.post(API_BASE_URL, productData, {
        headers: { "Content-Type": "application/json" },
      });
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Get all products with pagination and filters
   */
  async getAllProducts(params = {}) {
    try {
      const queryParams = new URLSearchParams();

      if (params.page) queryParams.append("page", params.page);
      if (params.limit) queryParams.append("limit", params.limit);
      if (params.search) queryParams.append("search", params.search);
      if (params.isActive !== undefined)
        queryParams.append("isActive", params.isActive);
      if (params.sort) queryParams.append("sort", params.sort);

      const response = await axios.get(
        `${API_BASE_URL}?${queryParams.toString()}`
      );
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Get single product by ID
   */
  async getProductById(productId) {
    try {
      const response = await axios.get(`${API_BASE_URL}/${productId}`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Update product
   */
  async updateProduct(productId, productData) {
    try {
      const response = await axios.put(
        `${API_BASE_URL}/${productId}`,
        productData,
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Delete product
   */
  async deleteProduct(productId) {
    try {
      const response = await axios.delete(`${API_BASE_URL}/${productId}`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Get all active products (for dropdowns)
   */
  async getActiveProducts() {
    try {
      const response = await axios.get(`${API_BASE_URL}/active/list`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Handle API errors
   */
  handleError(error) {
    if (error.response) {
      return {
        message: error.response.data?.message || "An error occurred",
        status: error.response.status,
        data: error.response.data,
      };
    } else if (error.request) {
      return {
        message: "Network error. Please check your connection.",
        status: 0,
      };
    } else {
      return {
        message: error.message || "An unexpected error occurred",
        status: 0,
      };
    }
  }
}

const productService = new ProductService();
export default productService;

